import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTrackViewedSignUpForm } from "@air/analytics";
import { Modal } from "@air/primitive-modal";
import { useAirModal } from "@air/provider-modal";
import { tailwindMerge } from "@air/tailwind-variants";
import noop from "lodash/noop";
import { useCallback, useEffect } from "react";
import { AirModalLogoHeader } from "~/components/Modals/AirModalLogoHeader";
import { LoginModal } from "~/components/Modals/LoginModal/LoginModal";
import { SignUpModalFooter } from "~/components/Modals/SignupModal/SignUpModalFooter";
import { SignUpModalForm } from "~/components/Modals/SignupModal/SignUpModalForm";
export const SignupModal = (param)=>{
    let { onSuccess = noop, ssoCallbackData, onClose, onCancel, accountCreationSource, overlayClassName } = param;
    const [showLoginModal] = useAirModal(LoginModal);
    const { trackViewedSignUpForm } = useTrackViewedSignUpForm();
    useEffect(()=>{
        trackViewedSignUpForm();
    }, [
        trackViewedSignUpForm
    ]);
    const onLoginClick = (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        onClose();
        showLoginModal({
            onSuccess,
            ssoCallbackData,
            accountCreationSource,
            onCancel
        });
    };
    const onDismiss = useCallback(()=>{
        onClose();
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    }, [
        onCancel,
        onClose
    ]);
    return /*#__PURE__*/ _jsxs(Modal, {
        // hide y scrollbar to avoid double scroll
        overlayClassName: tailwindMerge(overlayClassName, "overflow-y-hidden"),
        className: "max-h-[80vh] w-[414px] overflow-y-auto p-8",
        isOpen: true,
        onDismiss: onDismiss,
        "data-testid": "SIGNUP_MODAL",
        children: [
            /*#__PURE__*/ _jsx(AirModalLogoHeader, {
                onClose: onDismiss
            }),
            /*#__PURE__*/ _jsx("h1", {
                className: "mb-4 text-center text-20 font-semibold text-pigeon-700",
                children: "Sign Up"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-7",
                children: [
                    /*#__PURE__*/ _jsx(SignUpModalForm, {
                        closeModal: onClose,
                        ssoCallbackData: ssoCallbackData,
                        onSuccess: (account)=>{
                            onSuccess(account);
                            onClose();
                        },
                        accountCreationSource: accountCreationSource,
                        onLoginClick: onLoginClick
                    }),
                    /*#__PURE__*/ _jsx(SignUpModalFooter, {
                        onLoginClick: onLoginClick
                    })
                ]
            })
        ]
    });
};
